import { useTranslation } from '../../i18n/i18n';
import { Card, Typography } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import React from 'react';
import './ResetPasswordPage.scss';
import ResetPasswordForm from './ResetPasswordForm';

const { Title, Text } = Typography;
const ResetPasswordPage = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'restorePassword' });
  return (
    <>
      <div className={'RestorePassword'}>
        <Card className={'RestorePassword__Card'}>
          <div className={'RestorePassword__Card__TitleCard'}>
            <Title level={1} className={'RestorePassword__Card__TitleCard__Title Title'}>
              {t('welcome')}
            </Title>
            <img src={'/assets/images/KAIROS-negre.png'} alt={'Kairos'} className={'IdentityComponent__img'} />
          </div>
          <Card className={'RestorePassword__Card__InfoCard'}>
            <KeyOutlined />
            <div className={'RestorePassword__Card__InfoCard__Description'}>
              <Title level={5} className={'RestorePassword__Card__InfoCard__Description__Title'}>
                {t('title')}
              </Title>
              <Text>{t('description')} </Text>
            </div>
          </Card>
          <ResetPasswordForm />
        </Card>
      </div>
    </>
  );
};

export default ResetPasswordPage;
